// Sector icons and colors for the «По секторам» view of the positions (docs/design/SPEC.md, decision 34).
// One color per sector: the icon in full, the row background faded from the left. No pure green or red —
// those mean profit and loss.
import { t } from './i18n';

// 24 × 24 outline paths, stroke 1.6.
export const SECTOR_STYLES = {
  energy: { color: '#fb923c', icon: 'M12 3.5c3 4 5.5 7 5.5 10a5.5 5.5 0 0 1-11 0c0-3 2.5-6 5.5-10z' },
  utilities: { color: '#facc15', icon: 'M13 3 5 13.5h6L10 21l8-10.5h-6z' },
  materials: { color: '#d4a373', icon: 'M6 9l3-4h6l3 4-6 10zM6 9h12M9 5l3 4 3-4' },
  financial: { color: '#60a5fa', icon: 'M3.5 9 12 4.5 20.5 9M5.5 9.5v8M9.8 9.5v8M14.2 9.5v8M18.5 9.5v8M3.5 19.5h17' },
  real_estate: { color: '#c084fc', icon: 'M4 11 12 4.5 20 11M6 9.5v10h12v-10M10 19.5v-5h4v5' },
  consumer: { color: '#f472b6', icon: 'M5.5 8h13l-1 11.5h-11zM9 8V6.5a3 3 0 0 1 6 0V8' },
  it: { color: '#38bdf8', icon: 'M8.5 7.5 4 12l4.5 4.5M15.5 7.5 20 12l-4.5 4.5M13.5 5.5l-3 13' },
  telecom: { color: '#2dd4bf', icon: 'M12 20v-7M8.5 9.5a5 5 0 0 1 7 0M5.8 6.8a9 9 0 0 1 12.4 0M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0' },
  industrials: { color: '#a3e635', icon: 'M3.5 19.5V10l5 3v-3l5 3V5.5h4v14zM3.5 19.5h17' },
  health_care: { color: '#fda4af', icon: 'M9.5 4.5h5v5h5v5h-5v5h-5v-5h-5v-5h5z' },
  government: { color: '#e2e8f0', icon: 'M12 3.5 19 6v5.5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z' },
  funds: { color: '#a78bfa', icon: 'M12 4 20 8.5 12 13 4 8.5zM4 12.5 12 17l8-4.5M4 16.5 12 21l8-4.5' },
  cash: { color: '#94a3b8', icon: 'M3.5 7h17v10h-17zM9.5 12a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0' },
  other: { color: '#94a3b8', icon: 'M4.5 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0M10.5 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0M16.5 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0' },
  unlabelled: { color: '#94a3b8', icon: 'M4.5 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0M10.5 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0M16.5 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0' },
};

// Sector of a position as in the analytics: cash for currency, «без отрасли» without a label.
export function sectorOf(position) {
  if (position.instrument_type === 'currency') {
    return 'cash';
  }
  return position.industry?.sector ?? 'unlabelled';
}

export function sectorStyle(sector) {
  return SECTOR_STYLES[sector] ?? SECTOR_STYLES.unlabelled;
}

export function sectorName(sector) {
  return t(`sector.${sector}`);
}

// Row background: the sector color from 18 % on the left down to 4 % on the right.
export function sectorRowStyle(sector) {
  return { backgroundImage: `linear-gradient(to right, ${sectorStyle(sector).color}2e, ${sectorStyle(sector).color}0a)` };
}
